import { create } from 'zustand'

interface SchedulerState {
  /** Unix ms of the last scheduler tick (top of tick(), before
   *  any work). 0 means the runner has never ticked. The
   *  AutoFollow / Schedule pages render "Nₛ ago" so the operator
   *  can see at a glance whether the runner is alive. */
  lastTickAt: number
  setLastTick: (ms: number) => void
}

export const useScheduler = create<SchedulerState>((set) => ({
  lastTickAt: 0,
  setLastTick: (ms) => set({ lastTickAt: ms }),
}))
